import { isDsvAdminUser } from '@/hooks/use-dsv-admin/index';

const isDsvAdmin = (meta) => meta.dispatch(isDsvAdminGuardAction(meta));

const isDsvAdminGuardAction = () => (_dispatch, getState) => {
	if (isDsvAdminUser(getState().auth?.user)) {
		return null;
	}

	return '/';
};

export { isDsvAdmin };
